import { useMemo, useRef, useState } from 'react';

import { ListPagination } from 'src/common/components';
import { ModalRefProps } from 'src/common/components/Modal';
import { Table } from 'src/common/components/Table';
import { useQuery } from 'src/common/hooks/useQuery';

import { AlarmRuleModal } from './components/AlarmRuleModal';
import { ApiAccountType } from './types';

const Api: React.FC = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const alarmModalRef = useRef<ModalRefProps | null>(null);
  const { data, isLoading } = useQuery(`/account_admin?api_enable=true&page=${currentPage}`);
  const accounts = (data as { results: ApiAccountType[] })?.results || [];
  const totalCount = (data as { count: number })?.count || 0;

  const handleConfigureAlarms = (row: ApiAccountType): void => {
    alarmModalRef.current?.show(row);
  };

  const columns = useMemo(
    () => [
      { title: 'Account', index: 'name' },
      { title: 'ID', index: 'id' },
    ],
    []
  );

  const actions = useMemo(
    () => [
      {
        title: 'Configure alarms',
        icon: 'settings',
        callback: ({ row }: { row: ApiAccountType }) => handleConfigureAlarms(row),
      },
    ],
    []
  );

  return (
    <div className="sm:px-6 lg:px-8 flex flex-col h-full px-4 pt-8">
      <h2>API</h2>
      <p className="text-gray-2.0">
        Accounts that use BrainHi&apos;s API externally. This list is manually curated via the{' '}
        <code>api_enable</code> flag on an account&apos;s settings.
      </p>
      <div className="scrollbar-thin flex-1 mt-4 overflow-auto">
        <Table<ApiAccountType>
          data={accounts}
          columns={columns}
          actions={actions}
          loading={isLoading}
        />
      </div>
      <ListPagination
        currentPage={currentPage}
        totalCount={totalCount}
        setCurrentPage={setCurrentPage}
      />
      <AlarmRuleModal ref={alarmModalRef} />
    </div>
  );
};

export default Api;
